import React, { FC, useEffect, useState } from 'react';
import BookingPeriodSelector from '../../../components/BookingPeriodSelector';
import { IBookingObj } from '@types';
import { filterAndCountByState } from '../../../components/const';
import * as S from './styles';
import { selectOptions } from '@utils/const';

interface IProps {
    data: IBookingObj[] | undefined;
}

interface IISelector {
    key: string;
    value: string;
    label: string;
}

const HeaderBooking: FC<IProps> = ({ data }) => {
    const [selectValue, setSelectValue] = useState<IISelector>(
        selectOptions[0]
    );
    const [stat, setStat] = useState({ 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 });
    useEffect(() => {
        if (data && selectValue) {
            const statistic = filterAndCountByState(data, selectValue.value);
            setStat(statistic);
        }
    }, [data, selectValue]);
    const amount = stat[0] + stat[1] + stat[2] + stat[3] + stat[4];
    const canceled = stat[1] + stat[4];
    return (
        <S.HeaderReservationPageWrap>
            <S.CardInfo>
                <S.SelectCardTextArea>
                    <S.CardTexSelect>период статистики</S.CardTexSelect>
                    <BookingPeriodSelector
                        options={selectOptions}
                        setSelectValue={setSelectValue}
                        value={selectValue}
                    />
                </S.SelectCardTextArea>
            </S.CardInfo>

            <S.CardInfo>
                <S.CardTextArea>
                    <S.CardText>Всего</S.CardText>
                    <S.CardTitle>{amount}</S.CardTitle>
                </S.CardTextArea>
            </S.CardInfo>

            <S.CardInfo>
                <S.CardTextArea>
                    <S.CardText>Ожидание</S.CardText>
                    <S.CardTitle>{stat[0]}</S.CardTitle>
                </S.CardTextArea>
            </S.CardInfo>

            <S.CardInfo>
                <S.CardTextArea>
                    <S.CardText>Подтвержденных</S.CardText>
                    <S.CardTitle>{stat[2]}</S.CardTitle>
                </S.CardTextArea>
            </S.CardInfo>

            <S.CardInfo>
                <S.CardTextArea>
                    <S.CardText>Отказ</S.CardText>
                    <S.CardTitle>{canceled}</S.CardTitle>
                </S.CardTextArea>
            </S.CardInfo>
        </S.HeaderReservationPageWrap>
    );
};

export default HeaderBooking;
